<template>

</template>

<script>
export default {
  name: "MonthlySale"
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contents/main/home/MonthlySale.vue